import React from 'react';
import Config from '../../config/Config';
import { connect } from 'react-redux';

import Table from 'react-bootstrap/Table';
import Card from 'react-bootstrap/Card';
const Order = ({ orders, showErrorPage, orderErrMsg }) => {
	var Orderslist = (
		<tr>
			<td colSpan="4">No Orders found</td>
		</tr>
	);
	const userData = JSON.parse(localStorage.getItem('userDetails'));
	if (!!orders && Object.keys(orders).length > 0) {
		Orderslist = Object.keys(orders).map(function (order_key, index) {
			const { product_name, order_id, bill } = orders[order_key];

			return (
				<tr key={`order_${order_key}_${order_id}`}>
					<td data-label="S.No">{index + 1}</td>
					<td data-label="Product Name">{product_name}</td>
					<td data-label="Order ID">{order_id}</td>
					<td data-label="Summary">
						{!!bill ? (
							<a
								rel="noopener noreferrer"
								href={bill}
								className="download-link"
								target="_blank"
							>
								<img src={Config.ASSETSPATH + 'img/downloadicon.png'} alt="" />
								Download
							</a>
						) : !!userData &&
						  !!userData.full_name &&
						  userData.full_name !== 'null' ? (
							<span>Bill not generated yet.</span>
						) : (
							<span>
								Please update your Name{' '}
								<a href="/profile" className="download-link">
									here
								</a>{' '}
								to generate your bill.{' '}
							</span>
						)}
					</td>
				</tr>
			);
		});
	}
	return (
		<div>
			<div className="row">
				<div className="col-xs-12 col-md-12 col-sm-12 col-lg-12">
					<Card>
						<Card.Body>
							<Card.Title>
								<div className="page-header-left">Order History</div>
							</Card.Title>

							<div className="table-responsive table-bordered">
								<Table className="table CertificatesTable">
									<thead>
										<tr>
											<th>S.No</th>
											<th>Product Name</th>
											<th>Order ID</th>
											<th>
												<img src={Config.ASSETSPATH + 'img/summaryicon.png'} alt="" />
												Summary
											</th>
										</tr>
									</thead>
									<tbody>{Orderslist}</tbody>
								</Table>
							</div>
						</Card.Body>
					</Card>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { orders } = state.rootReducer.settingsDetails;
	return {
		orders,
	};
};

export default connect(mapStateToProps)(Order);
